export const countries = ['Deutschland', 'Österreich', 'Schweiz', 'Italien', 'EU-Ausland', 'Ausland'];
